/** 発送予定画面のデフォルト検索条件（URLパラメータなし初回表示と同じ） */
export const SHIPPING_ADJUST_DEFAULT_FILTERS = {
  productQuery: '',
  customerName: '',
  customerNameExact: false,
  startDate: '',
  endDate: '',
  searchBaseDate: 'order_date',
  shipmentDateNullOnly: false,
  shipmentDateSetOnly: false,
  hacchuDateFromToday: false,
  shipmentDateTodayOnly: false,
  shipmentDateFromToday: false,
  shipmentDateNextBusinessDay: false,
  shipmentDateFromNextBusinessDay: false,
  currentPeriodOnly: true,
  previousPeriodsOnly: false,
  defectiveOnly: false,
};

/**
 * URLSearchParams から発送予定のフィルタ状態を構築する。
 * @param {URLSearchParams} searchParams
 */
export function buildShippingAdjustFiltersFromSearchParams(searchParams) {
  return {
    ...SHIPPING_ADJUST_DEFAULT_FILTERS,
    productQuery: searchParams.get('product_query') || '',
    customerName: searchParams.get('customer_name') || '',
    customerNameExact: searchParams.get('customer_name_exact') === 'true',
    startDate: searchParams.get('start_date') || '',
    endDate: searchParams.get('end_date') || '',
    searchBaseDate: searchParams.get('search_base_date') || 'order_date',
    shipmentDateNullOnly: searchParams.get('shipment_date_null_only') === 'true',
    shipmentDateSetOnly: false,
    hacchuDateFromToday: searchParams.get('hacchu_date_from_today') === 'true',
    shipmentDateTodayOnly: searchParams.get('shipment_date_today_only') === 'true',
    shipmentDateFromToday: searchParams.get('shipment_date_from_today') === 'true',
    shipmentDateNextBusinessDay: searchParams.get('shipment_date_next_business_day') === 'true',
    shipmentDateFromNextBusinessDay: searchParams.get('shipment_date_from_next_business_day') === 'true',
    currentPeriodOnly: searchParams.get('current_period_only') !== 'false',
    previousPeriodsOnly: searchParams.get('previous_periods_only') === 'true',
    defectiveOnly: searchParams.get('cancel_return_issue_only') === 'true',
  };
}
